module.exports = "/images/oculus-7.jpg";